import React, { useState } from 'react';
import './App.css';
import { api } from './api';
import Footer from './components/Footer';

function SimpleApp() {
  const [numStocks, setNumStocks] = useState(5);
  const [targetBeta, setTargetBeta] = useState(1.0);
  const [portfolioData, setPortfolioData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const optimizePortfolio = async () => {
    setLoading(true);
    setError('');
    
    try {
      const { data } = await api.post('/optimize', {
        num_stocks: parseInt(numStocks),
        target_beta: parseFloat(targetBeta)
      });
      setPortfolioData(data);
    } catch (err) {
      setError(err.response?.data?.error || 'Cannot connect to backend. Please check your connection.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="app-simple" className="App">
      <div id="container-simple" className="container">
        <h1 id="title-simple">Simple Portfolio Optimizer</h1>
        <p id="subtitle-simple">No external APIs required - uses sample data for demonstration</p>
        
        <div id="input-section-simple" className="input-section">
          <div id="input-group-num-stocks-simple" className="input-group">
            <label id="label-num-stocks-simple" htmlFor="num-stocks-simple">Number of Stocks:</label>
            <input
              id="num-stocks-simple"
              type="number"
              value={numStocks}
              onChange={(e) => setNumStocks(e.target.value)}
              min="1"
              max="10"
            />
          </div>

          <div id="input-group-target-beta-simple" className="input-group">
            <label id="label-target-beta-simple" htmlFor="target-beta-simple">Target Beta:</label>
            <input
              id="target-beta-simple"
              type="number"
              step="0.1"
              value={targetBeta}
              onChange={(e) => setTargetBeta(e.target.value)}
              min="0.1"
              max="3.0"
            />
          </div>

          <button 
            id="btn-optimize-simple"
            onClick={optimizePortfolio} 
            disabled={loading}
            className="optimize-btn"
          >
            {loading ? 'Optimizing...' : 'Optimize Portfolio'}
          </button>
        </div>

        {error && (
          <div id="error-section-simple" className="error-message">
            <h3 id="error-heading-simple">Error:</h3>
            <p id="error-text-simple">{error}</p>
          </div>
        )}

        {portfolioData && (
          <div id="results-simple" className="results">
            <h2 id="results-title-simple">Portfolio Results</h2>
            <div id="metrics-simple" className="metrics">
              <div id="metric-expected-return-simple" className="metric">
                <label>Expected Return:</label>
                <span>{(portfolioData.expected_return * 100).toFixed(2)}%</span>
              </div>
              <div id="metric-volatility-simple" className="metric">
                <label>Volatility:</label>
                <span>{(portfolioData.volatility * 100).toFixed(2)}%</span>
              </div>
              <div id="metric-sharpe-simple" className="metric">
                <label>Sharpe Ratio:</label>
                <span>{portfolioData.sharpe_ratio.toFixed(3)}</span>
              </div>
              <div id="metric-beta-simple" className="metric">
                <label>Portfolio Beta:</label>
                <span>{portfolioData.actual_beta.toFixed(2)}</span>
              </div>
            </div>

            <h3 id="weights-heading-simple">Stock Weights:</h3>
            <div id="weights-list-simple" className="weights">
              {Object.entries(portfolioData.weights)
                .filter(([, weight]) => weight > 0.001)
                .map(([symbol, weight]) => (
                <div key={symbol} id={`weight-item-${symbol}-simple`} className="weight-item">
                  <span className="symbol">{symbol}</span>
                  <span className="weight">{(weight * 100).toFixed(1)}%</span>
                </div>
              ))}
            </div>

            <p id="message-simple" className="message">{portfolioData.message}</p>
          </div>
        )}

        <Footer />
      </div>
    </div>
  );
}

export default SimpleApp;
